import { inject, Inject, Injectable, Optional } from '@angular/core';
import { DateTime } from 'luxon';
import { REQUEST, RESPONSE } from '../../../express.tokens';
import { IS_SERVER_TOKEN } from '../tokens/is-server.token';
import { IS_SSR_MODE_TOKEN } from '../tokens/is-ssr-mode.token';

// TODO: 也許根據SSR/CSR判斷引入不同Logger策略
/** 日誌，只有 console 打印 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  protected isServer = inject(IS_SERVER_TOKEN);
  protected isSSRMode = inject(IS_SSR_MODE_TOKEN);

  constructor(
    @Optional() @Inject(REQUEST) protected request: Request,
    @Optional() @Inject(RESPONSE) protected response: Response,
  ) { }

  info(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['info'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.log(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'info'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.log(msg, ...optionalParams);
    }
  }

  warn(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['warn'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.warn(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'warn'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.warn(msg, ...optionalParams);
    }
  }

  error(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['error'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.error(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'error'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.error(msg, ...optionalParams);
    }
  }
}
